var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{staticClass:"PublicBanner",attrs:{"width-100-percent":"","overflow-hidden":""}},[(_vm.displayIsTablet || _vm.displayIsDesktop)?_c('LargeHero'):_c('SmallHero')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }